exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".strikethrough {\n  text-decoration: line-through;\n  opacity: 0.5; }\n", ""]);

